export default __webpack_public_path__ + "static/media/Declaration of Independence_11.d8553664.jpg";